import React from "react";
import logo from "./boomIcon.svg";

export default function LogoIcon(props) {
  return <img src={logo} alt="Logo" {...props} />;
}
